<template>
  <div class="BookartNumber">
    <input
      type="number"
      v-model.number="internal"
      @blur="onBlur"
      :style="{ width: width }"
      :step="step"
      :min="min"
      :max="max"
    ></input>
  </div>
</template>

<script>
export default {
  name: 'bookart-number',

  props: {
    value: {
      type: Number,
      default: 0
    },
    step: {
      type: Number,
      default: 1
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: Infinity
    },
  },

  data () {
    return {
      internal: this.value
    }
  },

  computed: {
    width () {
      let digits = String(this.internal).replace(/[^0-9]/g, '').length
      return Math.max(digits * 10 + 50, 100) + 'px'
    },

    isValid () {
      const value = parseInt(this.internal / this.step) * this.step
      return value >= this.min && value <= this.max
    }
  },

  watch: {
    value (val) {
      this.internal = val
    },

    internal (val) {
      if (this.isValid) this.$emit('input', this.internal)
    }
  },

  methods: {
    onBlur () {
      if (!this.isValid) this.internal = this.min
    }
  }
}
</script>

<style lang="stylus">

@import '../../styles/vars'

.BookartNumber
  display: inline-block

  input
    padding: 1rem 0 1rem .5rem
    border: 0
    background: $lavender
    color: white
    text-align: center
</style>



// WEBPACK FOOTER //
// BookartNumber.vue?fb4bad14